/*
  Welcome offer dialog. Opens once per browser after a delay, and opens straight
  away when the page comes back from a successful signup so the code is shown.
*/
if (!customElements.get('alepu-welcome')) {
  const SEEN = 'alepu-welcome-seen';
  const DONE = 'alepu-welcome-done';

  const flag = (key) => {
    try {
      return localStorage.getItem(key) === '1';
    } catch (e) {
      return false;
    }
  };

  const setFlag = (key) => {
    try {
      localStorage.setItem(key, '1');
    } catch (e) {}
  };


  customElements.define(
    'alepu-welcome',
    class AlepuWelcome extends HTMLElement {
      connectedCallback() {
        this.panel = this.querySelector('.alepu-welcome__panel');
        this.onKeydown = (event) => {
          if (event.key === 'Escape') this.close();
        };

        this.querySelectorAll('[data-welcome-close]').forEach((el) =>
          el.addEventListener('click', () => this.close())
        );

        /* The floating button stays until someone has signed up, and steps aside
           at the footer the same way the ritual launcher does. */
        this.launcher = this.querySelector('[data-welcome-open]');
        if (this.launcher) {
          this.launcher.addEventListener('click', () => this.open());
          const footer = document.querySelector('.footer');
          if (footer) {
            this.footerObserver = new IntersectionObserver((entries) => {
              this.launcher.classList.toggle('is-tucked', entries[0].isIntersecting);
            });
            this.footerObserver.observe(footer);
          }
        }

        if (this.querySelector('[data-welcome-success]')) setFlag(DONE);
        if (this.launcher) this.launcher.hidden = flag(DONE);
        this.querySelectorAll('[data-welcome-copy]').forEach((el) =>
          el.addEventListener('click', () => {
            if (navigator.clipboard) navigator.clipboard.writeText(el.dataset.welcomeCopy);
            el.textContent = el.dataset.copiedLabel || '✓';
          })
        );

        if (this.querySelector('[data-welcome-success]') || this.querySelector('[aria-invalid]')) {
          this.open();
          return;
        }
        if (flag(SEEN) || flag(DONE) || document.body.classList.contains('alepu-ritual-locked')) return;

        this.timer = setTimeout(() => {
          if (!document.body.classList.contains('alepu-ritual-locked')) this.open();
        }, (parseInt(this.dataset.delay, 10) || 8) * 1000);
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        if (this.footerObserver) this.footerObserver.disconnect();
        document.removeEventListener('keydown', this.onKeydown);
      }

      open() {
        setFlag(SEEN);
        this.classList.add('is-open');
        document.addEventListener('keydown', this.onKeydown);
        if (typeof trapFocus === 'function') trapFocus(this.panel, this.panel.querySelector('input, button'));
      }

      close() {
        this.classList.remove('is-open');
        document.removeEventListener('keydown', this.onKeydown);
        if (typeof removeTrapFocus === 'function') removeTrapFocus(this.launcher && !this.launcher.hidden ? this.launcher : undefined);
      }
    }
  );
}
